import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuItem from '@material-ui/core/MenuItem';


export default function Pagination(props) {
  const {
    pages, currentPage, onPageChange, className,
  } = props;
  if (pages.indexOf(currentPage) === -1) {
    return (
      <div>
        {'Invalid page'}
      </div>
    );
  }

  return (
    <div className={className}>
      <IconButton
        onClick={() => {
          const newPage = pages[pages.indexOf(currentPage) - 1];
          onPageChange(newPage);
        }}
        disabled={pages.indexOf(currentPage) === 0}
      >
        <FontAwesomeIcon icon="angle-left" size="xs" />
      </IconButton>
      <Select
        MenuProps={{ style: { maxHeight: '600px' } }}
        value={currentPage}
        onChange={(event) => {
          const newPage = event.target.value;
          if (newPage !== currentPage) onPageChange(newPage);
        }}
      >
        {pages.map(page => (
          <MenuItem key={page} value={page}>
            {page}
          </MenuItem>
        ))}
      </Select>
      <IconButton
        onClick={() => {
          const newPage = pages[pages.indexOf(currentPage) + 1];
          onPageChange(newPage);
        }}
        disabled={pages.indexOf(currentPage) === pages.length - 1}
      >
        <FontAwesomeIcon icon="angle-right" size="xs" />
      </IconButton>
    </div>
  );
}

Pagination.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onPageChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
Pagination.defaultProps = {
  className: null,
};



// WEBPACK FOOTER //
// ./src/layout/logbook/Pagination.jsx